// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VenueDetail_venue-detail__Sp4ta {
  display: flex;
  flex-direction: column;
  gap: 80px;
}
.VenueDetail_venue-detail__Sp4ta p {
  line-height: 1.5 !important;
}
.VenueDetail_venue-detail__Sp4ta .VenueDetail_venue-detail-word-map__4c1DJ {
  display: flex !important;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 30px;
  padding: 25px;
}
.VenueDetail_venue-detail__Sp4ta .VenueDetail_venue-detail-word-map__4c1DJ .VenueDetail_keyword-cloud__7TNHC {
  display: flex;
  align-items: center;
  flex: 1 1;
  border: 1px var(--light-blue) solid;
  border-radius: 12px;
  padding: 16px;
}
.VenueDetail_venue-detail__Sp4ta .VenueDetail_top-result__\\+jmro {
  padding: 32px;
}
.VenueDetail_venue-detail__Sp4ta > *:not(:last-child) {
  border-bottom: 1px solid var(--light-grey);
}
@media only screen and (max-width: 480px) {
  .VenueDetail_venue-detail__Sp4ta {
    flex-direction: column !important;
  }
  .VenueDetail_venue-detail__Sp4ta .VenueDetail_academic-result__jGaqR {
    margin-top: 20px;
    width: 100%;
  }
}

.VenueDetail_ant-tabs-tab-active__HxwAw .VenueDetail_ant-tabs-tab-btn__B3t94 {
  color: var(--blue) !important;
}
.VenueDetail_ant-tabs-tab-active__HxwAw .VenueDetail_ant-tabs-tab-btn__B3t94:hover {
  color: var(--blue) !important;
}

@media only screen and (max-width: 480px) {
  .VenueDetail_venue-detail__Sp4ta {
    gap: 32px;
  }
  .VenueDetail_venue-detail__Sp4ta .VenueDetail_venue-detail-word-map__4c1DJ {
    margin-bottom: 30px;
    padding: 0 16px;
  }
  .VenueDetail_venue-detail__Sp4ta .VenueDetail_venue-detail-word-map__4c1DJ .VenueDetail_keyword-cloud__7TNHC {
    display: flex;
    align-items: center;
    flex: 1 1;
    border: none;
    border-radius: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/VenueDetail/VenueDetail.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,2BAAA;AACJ;AAEE;EACE,wBAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;AAAN;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,0CAAA;AAHJ;AAME;EAlCF;IAmCI,iCAAA;EAHF;EAKE;IACE,gBAAA;IACA,WAAA;EAHJ;AACF;;AAQE;EACE,6BAAA;AALJ;AAQE;EACE,6BAAA;AANJ;;AAUA;EACE;IACE,SAAA;EAPF;EASE;IACE,mBAAA;IACA,eAAA;EAPJ;EASI;IACE,aAAA;IACA,mBAAA;IACA,SAAA;IACA,YAAA;IACA,gBAAA;EAPN;AACF","sourcesContent":[".venue-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 80px;\n\n  p {\n    line-height: 1.5 !important;\n  }\n\n  .venue-detail-word-map {\n    display: flex !important;\n    flex-direction: column;\n    gap: 24px;\n    margin-bottom: 30px;\n    padding: 25px;\n\n    .keyword-cloud {\n      display: flex;\n      align-items: center;\n      flex: 1;\n      border: 1px var(--light-blue) solid;\n      border-radius: 12px;\n      padding: 16px;\n    }\n  }\n\n  .top-result {\n    padding: 32px;\n  }\n\n  > *:not(:last-child) {\n    border-bottom: 1px solid var(--light-grey);\n  }\n\n  @media only screen and (max-width: 480px) {\n    flex-direction: column !important;\n\n    .academic-result {\n      margin-top: 20px;\n      width: 100%;\n    }\n  }\n}\n\n.ant-tabs-tab-active {\n  .ant-tabs-tab-btn {\n    color: var(--blue) !important;\n  }\n\n  .ant-tabs-tab-btn:hover {\n    color: var(--blue) !important;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .venue-detail {\n    gap: 32px;\n\n    .venue-detail-word-map {\n      margin-bottom: 30px;\n      padding: 0 16px;\n\n      .keyword-cloud {\n        display: flex;\n        align-items: center;\n        flex: 1;\n        border: none;\n        border-radius: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"venue-detail": `VenueDetail_venue-detail__Sp4ta`,
	"venue-detail-word-map": `VenueDetail_venue-detail-word-map__4c1DJ`,
	"keyword-cloud": `VenueDetail_keyword-cloud__7TNHC`,
	"top-result": `VenueDetail_top-result__+jmro`,
	"academic-result": `VenueDetail_academic-result__jGaqR`,
	"ant-tabs-tab-active": `VenueDetail_ant-tabs-tab-active__HxwAw`,
	"ant-tabs-tab-btn": `VenueDetail_ant-tabs-tab-btn__B3t94`
};
export default ___CSS_LOADER_EXPORT___;
